<template>
  <h1>Stores Component</h1>
</template>

<script lang="ts" setup></script>
